// extracted by mini-css-extract-plugin
module.exports = {"header-content-wrapper":"header-content-wrapper___22Sb7"};